import { listCliniciansApi } from "./adminCliniciansApi";

/** Keys for the admin portal's screen-data cache (see useCachedQuery). */
export const adminQueryKeys = {
  reviewQueue: "admin:review-queue",
  reviewQueueItem: (id: string) => `admin:review-queue-item:${id}`,
  clinicians: "admin:clinicians",
  /** Prefix — one entry per status filter. */
  invitations: "admin:invitations:",
  patients: "admin:patients:",
  patient: (patientId: string) => `admin:patient:${patientId}`,
  patientClinician: (patientId: string) => `admin:patient-clinician:${patientId}`,
};

/** Clinicians list as cached data — shared by the Clinicians tab and both assign pickers. */
export const fetchAdminClinicians = async () => {
  const { data, error } = await listCliniciansApi();
  return { data: data?.items ?? null, error };
};
